import { InAppState } from "../base/InAppState";
import template from "./ProfileTemplate.html";
import { _lcs, locale } from "../../i18n";

// Role key -> label (German source strings, translated where read).
const ROLE_LABELS = {
    admin  : "Admin",
    client : "Client",
    guest  : "Gast"
};

/**
 * ProfileState — "Mein Profil" (account menu): the signed-in operator's own
 * account. The client-admin's profile minus the accommodations — an operator
 * reaches every house through "Unterkünfte" instead.
 */
export class ProfileState extends InAppState
{
    static ROUTE = '/profile';
    static ID = 'profile';

    async enter()
    {
        const user = this.app.session?.user || {};
        const name = String( user.data?.name || "" ).trim();
        const since = user.createdAt ? new Date( user.createdAt ) : null;

        this.app.view.render( this.app.view.pageContent, template, {
            "account" : {
                "name" : name || this.app.user.name,
                "initials" : this.app.user.initials || "",
                "email" : user.email || "",
                "roles" : ( Array.isArray( user.role ) ? user.role : [] ).map( ( r ) => ( {
                    "key" : ROLE_LABELS[ r ] ? r : "other",
                    "label" : ROLE_LABELS[ r ] ? _lcs( ROLE_LABELS[ r ] ) : r
                } ) ),
                "since" : since && !isNaN( since.getTime() )
                    ? since.toLocaleDateString( locale(), { day : "2-digit", month : "long", year : "numeric" } )
                    : ""
            }
        } );

        this.addEventListener( this.app.view.pageContent, "click", ( e ) =>
        {
            if ( e.target.closest( '[data-action="settings"]' ) )
            {
                e.preventDefault();
                this.app.router.redirect( "/settings" );
            }
        } );
    }

    getContentHeaderData()
    {
        return {
            title: _lcs( "Mein Profil" ),
            subtitle: _lcs( "Dein Konto" )
        };
    }
}
